/* eslint-disable react/no-children-prop */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectActiveWorkspaces, selectLoadingWsForDropdown } from 'store/Workspace/selectors';
import SearchList from 'Common/Components/SearchList';
import { SelectShowCloudAgents, selectTriggerAgentWs, selectTriggerCloudAgentWs } from 'store/Agents/selectors';
import { addTriggerAgentWs, addTriggerCloudAgentWs, removeTriggerAgentWs, removeTriggerCloudAgentWs } from 'store/Agents/actions';
import { useIntl } from 'react-intl';
import {
  Wrapper, WrapperField, Label,
  WorkspaceList, Workspace, Name, TrashIcon
} from './styled';
import { getWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import useTheme from 'Hooks/UseTheme';
import get from 'lodash/get';

const WorkspaceSelector = ({ currentTool, onRemove, onSelect, disabled }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const isCloudAgent = useSelector(SelectShowCloudAgents);
  const loadingWorkspaces = useSelector(selectLoadingWsForDropdown);
  const addedWsUserAgent = useSelector((state) => selectTriggerAgentWs(state, get(currentTool, 'id', 0)));
  const addedWsCloudAgent = useSelector(selectTriggerCloudAgentWs);
  const addedWorkspaces = isCloudAgent ? addedWsCloudAgent : addedWsUserAgent;
  const allWorkspaces = useSelector(selectActiveWorkspaces);
  const notAddedWorkspaces = addedWorkspaces
    ? allWorkspaces.filter(ws =>
      addedWorkspaces.every(added => ws.id !== added.id)
    )
    : allWorkspaces;
  const workspaceList = notAddedWorkspaces.map((ws) => ({ primary: ws.name, id: ws._id }));

  const isOdd = (workspaceNumber) => workspaceNumber % 2 !== 0;
  const { themeStyles } = useTheme();

  const label = intl.formatMessage({ id: 'agents.triggerAgent.wsSelector.label' });

  const onRemoveWs = (ws) => {
    if (!disabled) {
      onSelect && onRemove(ws);
      if (isCloudAgent) dispatch(removeTriggerCloudAgentWs(ws, currentTool));
      else dispatch(removeTriggerAgentWs(ws, currentTool));
    }
  };

  const onSelectWs = (ws) => {
    onRemove && onSelect(ws);
    if (isCloudAgent) dispatch(addTriggerCloudAgentWs(ws.primary));
    else dispatch(addTriggerAgentWs(ws.primary, currentTool));
  };

  useEffect(() => {
    dispatch(getWorkspaces(false, false));
  }, [dispatch]);

  return (
    <Wrapper>
      <Label children={ label } />
      <WrapperField>
        <SearchList onSelect={ onSelectWs } items={ workspaceList } loadingData={ loadingWorkspaces } disabled={ disabled } />
        { addedWorkspaces?.length > 0
          ? <WorkspaceList>
             {addedWorkspaces.map((ws, i) => (
                <Workspace key={ `Workspace_${ws}` } isOdd={ isOdd(i) } theme={ themeStyles }>
                  <Name>{ ws }</Name>
                  <TrashIcon onClick={ () => onRemoveWs(ws) } />
                </Workspace>
             ))}
            </WorkspaceList>
          : null
        }

      </WrapperField>
    </Wrapper>
  );
};

export default WorkspaceSelector;
